import { api } from "./api";
import type {
  CreateOrganisationInput,
  Organisation,
  OrganisationAction,
  OrganisationContact,
  OrganisationGeofence,
  OrganisationMember,
  OrganisationRole,
  UpdateOrganisationMemberRoleInput,
} from "@/types/organisation";

export const organisationService = {
  getOrganisations: (): Promise<Organisation[]> =>
    api.get<Organisation[]>("/organisation").then((res) => res.data),

  getOrganisation: (id: number | string): Promise<Organisation> =>
    api.get<Organisation>(`/organisation/${id}`).then((res) => res.data),

  getOrganisationMembers: (id: number | string): Promise<OrganisationMember[]> =>
    api.get<OrganisationMember[]>(`/organisation/${id}/members`).then((res) => res.data),

  getOrganisationContacts: (id: number | string): Promise<OrganisationContact[]> =>
    api.get<OrganisationContact[]>(`/organisation/${id}/contacts`).then((res) => res.data),

  getOrganisationGeofences: (id: number | string): Promise<OrganisationGeofence[]> =>
    api.get<OrganisationGeofence[]>(`/organisation/${id}/geofences/`).then((res) => res.data),

  getOrganisationActions: (id: number | string): Promise<OrganisationAction[]> =>
    api.get<OrganisationAction[]>(`/organisation/${id}/actions`).then((res) => res.data),

  createOrganisation: (orgData: CreateOrganisationInput) =>
    api.post("/organisation", orgData),

  updateOrganisation: (id: number | string, orgData: Partial<Organisation>) =>
    api.put(`/organisation/${id}`, orgData),

  deleteOrganisation: (id: number | string) => api.delete(`/organisation/${id}`),

  deleteOrganisationMember: (organisationId: number | string, userId: number | string) =>
    api.delete(`/organisation/${organisationId}/members/${userId}`),

  updateOrganisationMembers: (
    organisationId: number | string,
    memberIds: (number | string)[],
  ) => api.put(`/organisation/${organisationId}/members`, { members: memberIds }),

  changeOrganisationOwner: (organisationId: number | string, ownerId: number | string) =>
    api.put(`/organisation/${organisationId}/owner`, { owner_id: ownerId }),

  changeOrganisationName: (organisationId: number | string, name: string) =>
    api.put(`/organisation/${organisationId}/name`, { name }),

  getOrganisationRoles: (organisationId: number | string): Promise<OrganisationRole[]> =>
    api.get<OrganisationRole[]>(`/organisation/${organisationId}/roles`).then((res) => res.data),

  updateOrganisationMemberRole: (
    organisationId: number | string,
    userId: number | string,
    roleData: UpdateOrganisationMemberRoleInput,
  ) => api.put(`/organisation/${organisationId}/roles/${userId}`, roleData),
};
